import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "@environment/environment";

export const mockCaseInterceptor: HttpInterceptorFn = (req, next) => {
  if (!environment.mockEnabled) {
    return next(req);
  }

  const mockCase =
    typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem("aria_mock_case")
      : null;

  if (mockCase) {
    const reqWithCase = req.clone({
      setHeaders: {
        "x-aria-mock-case": mockCase,
      },
    });
    return next(reqWithCase);
  }

  const mockProfile =
    typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem("aria_mock_profile")
      : null;

  if (mockProfile) {
    const reqWithProfile = req.clone({
      setHeaders: {
        "x-aria-mock-profile": mockProfile,
      },
    });
    return next(reqWithProfile);
  }

  return next(req);
};
